import React, { useContext, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import cn from 'classnames'
import { CustomerContext } from '../../../contexts/CustomerContext'
import usePastImages from './usePastImages'
import useLocalStorage from '../../../hooks/useLocalStorage'
import styles from './NewPastImages.module.scss'
import usePastImagesPricelist from './usePastImagesPricelist'
import TwoRowImageMarkup from './TwoRowImageMarkup'
import PastImage from './PastImage'
import SixImageMarkup from './SixImageMarkup';

function Wrapper({ children }) {
  return (
    <div>
      <p>Our children grow up so fast! Don’t miss a single year of memories</p>
      {children}
    </div>
  )
}

export default function NewPastImages() {
  // TODO: navigate to multi pose package builder with converted selected images
  const { customer } = useContext(CustomerContext)
  const history = useHistory()
  const location = useLocation()
  const [isUsingAccessCode] = useLocalStorage('isUsingAccessCode')
  const { loading: pricelistLoading, pricelist } = usePastImagesPricelist()
  const [selectedImages, setSelectedImages] = useState([])

  const toggleImage = (newStudentImage) => {
    if (selectedImages.map(((studentImage) => studentImage.id)).includes(newStudentImage.id)) {
      setSelectedImages(selectedImages.filter((selectedImage) => selectedImage.id !== newStudentImage.id))
    } else {
      setSelectedImages([...selectedImages, newStudentImage])
    }
  }

  const isPastImages = location.pathname.includes('past_images')
  const isDownloadImages = location.pathname.includes('download-image')

  const cartKey = customer.priorityCart ? 'priorityCart' : 'cart'

  const { loading, studentImages, hasNoPastImages } = usePastImages({
    cart: customer[cartKey],
    currentStudent: customer.currentStudent,
    isDownloadImages,
    isUsingAccessCode,
  })

  if (loading || pricelistLoading) return 'Loading...'

  const TEST_IMAGES = [...studentImages]
  const TEST_LENGTH = TEST_IMAGES.length

  if (TEST_LENGTH === 6) {
    return (
      <Wrapper>
        <SixImageMarkup
          studentImages={TEST_IMAGES}
          backgroundUrl={pricelist.defaultBackgroundUrl}
          selectedImages={selectedImages}
          toggleImage={toggleImage}
        />
      </Wrapper>
    )
  }

  if (TEST_LENGTH >= 5) {
    return (
      <Wrapper>
        <TwoRowImageMarkup
          studentImages={TEST_IMAGES}
          backgroundUrl={pricelist.defaultBackgroundUrl}
          selectedImages={selectedImages}
          toggleImage={toggleImage}
        />
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <div className={cn(styles.imageContainer, styles[`imageContainer${TEST_LENGTH}`])}>
        {studentImages.slice(0, TEST_LENGTH).map((studentImage) => (
          <PastImage
            studentImage={studentImage}
            backgroundUrl={pricelist.defaultBackgroundUrl}
            selectedImages={selectedImages}
            toggleImage={toggleImage}
          />
        ))}
      </div>
    </Wrapper>
  )
}
